/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDeliveryAreas200ResponseInnerType
 */
export interface GetDeliveryAreas200ResponseInnerType {
}

/**
 * Check if a given object implements the GetDeliveryAreas200ResponseInnerType interface.
 */
export function instanceOfGetDeliveryAreas200ResponseInnerType(value: object): value is GetDeliveryAreas200ResponseInnerType {
    return true;
}

export function GetDeliveryAreas200ResponseInnerTypeFromJSON(json: any): GetDeliveryAreas200ResponseInnerType {
    return GetDeliveryAreas200ResponseInnerTypeFromJSONTyped(json, false);
}

export function GetDeliveryAreas200ResponseInnerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliveryAreas200ResponseInnerType {
    return json;
}

export function GetDeliveryAreas200ResponseInnerTypeToJSON(json: any): GetDeliveryAreas200ResponseInnerType {
    return GetDeliveryAreas200ResponseInnerTypeToJSONTyped(json, false);
}

export function GetDeliveryAreas200ResponseInnerTypeToJSONTyped(value?: GetDeliveryAreas200ResponseInnerType | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

